import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration } from '../../../core';
import { TransactionTypes } from '../../../data';
let template = require('./activity-grid.html');

class ActivityGridComponent extends ComponentRegistration {

    constructor() {
        super('activityGrid', {
            controller: ActivityGridController,
            templateUrl: template,
            controllerAs: 'activityGrid',
            bindings: {
                showFilters: '@',
                activities: '<',
                offsetPixels: '@',
                showCredit: '@',
                showBalance: '@',
                showDebit: '@',
                showReservedParkingFilters: '<'
            }
        });
    }
}

interface IActivityGridController {
    onFilterChange(): void;
}

class ActivityGridController implements IActivityGridController {
    private static $inject: Array<string> = ['$scope'];

    //private fields
    private filteredActivities: Array<any>;
    private transactionTypes: Array<any> = [];
    private transactionType: string = null;
    private minAmount: string = null;
    private maxAmount: string = null;
    private showPointsOnly: Boolean = false;
    private showFrequentParker: Boolean = false;
    private showTransponderInfoCols: Boolean = false;
    private showEntryExitCols: Boolean = false;

    //bindings
    private showFilters: string;
    private activities: Array<any>;
    private offsetPixels: string;
    private showReservedParkingFilters: boolean = true;
    constructor(private $scope: ng.IScope) {

        console.log("ActivityGridController loading");

    }

    public $onInit(): void {
        this.filteredActivities = this.activities;

        this.transactionTypes = ng.copy(TransactionTypes);       

        this.transactionType = this.transactionTypes[0].value;

        let self = this;
        this.$scope.$watch("activityGrid.activities", () => { self.onFilterChange() });

        console.log("ActivityGridController loaded");
    }

    public removeNonApplicableTypes(): void {   
        if (this.showReservedParkingFilters == false) {
            this.transactionTypes.remove(x => x.key === 1 || x.key === 3 || x.key === 4);
        }
    }

    public onFilterChange(): void {
        console.log('AccountActivityController: onFilterChange');
        this.removeNonApplicableTypes();
        this.showFrequentParker = Linq.from(this.activities).Any((x) => {
            return x.fpActivity;
        });

        this.filteredActivities = [];
        for (var index = 0; index < this.activities.length; index++) {
            var activity = this.activities[index];
            if (
                ((this.minAmount == null || this.minAmount == '') || (activity.accountActivity.amount >= Number(this.minAmount))) &&
                ((this.maxAmount == null || this.maxAmount == '') || (activity.accountActivity.amount <= Number(this.maxAmount))) &&
                ((this.transactionType === 'All') ||
                    (activity.accountActivity.transactionType === 6 && this.transactionType === 'Parking Trip') ||
                    (activity.accountActivity.transactionType === 1 && this.transactionType === 'Replenishment') ||
                    (activity.accountActivity.transactionType === 2 && this.transactionType === 'Manual Adjustment') ||
                    (activity.accountActivity.transactionType === 4 && this.transactionType === 'Year-End Adjustment')) &&
                ((!this.showPointsOnly) || (activity.fpActivity != null))
            ) {
                this.filteredActivities.push(activity);
            }
        }
    }

}

let actgrdComponent = new ActivityGridComponent();
export default actgrdComponent;
export { actgrdComponent as ActivityGridComponent, IActivityGridController, ActivityGridController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/user-controls/activity-grid.ts